// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0ruOZ","actions":"styles_actions__NBVwL","text":"styles_text__t15I7"};